export default [
  {text: '246 - Banco ABC Brasil S.A.', value: '246'},
  {text: '075 - Banco ABN AMRO S.A.', value: '075'},
  {text: '121 - Banco Agibank S.A.', value: '121'},
  {text: '025 - Banco Alfa S.A.', value: '025'},
  {text: '641 - Banco Alvorada S.A.', value: '641'},
  {text: '065 - Banco Andbank (Brasil) S.A.', value: '065'},
  {text: '096 - Banco B3 S.A.', value: '096'},
  {text: '024 - Banco BANDEPE S.A.', value: '024'},
  {text: '318 - Banco BMG S.A.', value: '318'},
  {text: '752 - Banco BNP Paribas Brasil S.A.', value: '752'},
  {text: '107 - Banco BOCOM BBM S.A.', value: '107'},
  {text: '063 - Banco Bradescard S.A.', value: '063'},
  {text: '036 - Banco Bradesco BBI S.A.', value: '036'},
  {text: '204 - Banco Bradesco Cartões S.A.', value: '204'},
  {text: '394 - Banco Bradesco Financiamentos S.A.', value: '394'},
  {text: '237 - Banco Bradesco S.A.', value: '237'},
  {text: '218 - Banco BS2 S.A.', value: '218'},
  {text: '208 - Banco BTG Pactual S.A.', value: '208'},
  {text: '473 - Banco Caixa Geral - Brasil S.A.', value: '473'},
  {text: '040 - Banco Cargill S.A.', value: '040'},
  {text: '739 - Banco Cetelem S.A.', value: '739'},
  {text: '233 - Banco Cifra S.A.', value: '233'},
  {text: '745 - Banco Citibank S.A.', value: '745'},
  {text: '756 - Banco Cooperativo do Brasil S.A. - BANCOOB', value: '756'},
  {text: '748 - Banco Cooperativo Sicredi S.A.', value: '748'},
  {text: '222 - Banco Credit Agricole Brasil S.A.', value: '222'},
  {text: '505 - Banco Credit Suisse (Brasil) S.A.', value: '505'},
  {text: '003 - Banco da Amazônia S.A.', value: '003'},
  {text: '083 - Banco da China Brasil S.A.', value: '083'},
  {text: '707 - Banco Daycoval S.A.', value: '707'},
  {text: '001 - Banco do Brasil S.A.', value: '001'},
  {text: '047 - Banco do Estado de Sergipe S.A.', value: '047'},
  {text: '037 - Banco do Estado do Pará S.A.', value: '037'},
  {text: '041 - Banco do Estado do Rio Grande do Sul S.A.', value: '041'},
  {text: '004 - Banco do Nordeste do Brasil S.A.', value: '004'},
  {text: '265 - Banco Fator S.A.', value: '265'},
  {text: '224 - Banco Fibra S.A.', value: '224'},
  {text: '612 - Banco Guanabara S.A.', value: '612'},
  {text: '012 - Banco Inbursa S.A.', value: '012'},
  {text: '604 - Banco Industrial do Brasil S.A.', value: '604'},
  {text: '653 - Banco Indusval S.A.', value: '653'},
  {text: '077 - Banco Inter S.A.', value: '077'},
  {text: '249 - Banco Investcred Unibanco S.A.', value: '249'},
  {text: '184 - Banco Itaú BBA S.A.', value: '184'},
  {text: '029 - Banco Itaú Consignado S.A.', value: '029'},
  {text: '479 - Banco ItauBank S.A', value: '479'},
  {text: '376 - Banco J. P. Morgan S.A.', value: '376'},
  {text: '074 - Banco J. Safra S.A.', value: '074'},
  {text: '217 - Banco John Deere S.A.', value: '217'},
  {text: '600 - Banco Luso Brasileiro S.A.', value: '600'},
  {text: '389 - Banco Mercantil do Brasil S.A.', value: '389'},
  {text: '370 - Banco Mizuho do Brasil S.A.', value: '370'},
  {text: '746 - Banco Modal S.A.', value: '746'},
  {text: '456 - Banco MUFG Brasil S.A.', value: '456'},
  {text: '169 - Banco Olé Bonsucesso Consignado S.A.', value: '169'},
  {text: '212 - Banco Original S.A.', value: '212'},
  {text: '623 - Banco PAN S.A.', value: '623'},
  {text: '611 - Banco Paulista S.A.', value: '611'},
  {text: '643 - Banco Pine S.A.', value: '643'},
  {text: '747 - Banco Rabobank International Brasil S.A.', value: '747'},
  {text: '633 - Banco Rendimento S.A.', value: '633'},
  {text: '120 - Banco Rodobens S.A.', value: '120'},
  {text: '422 - Banco Safra S.A.', value: '422'},
  {text: '033 - Banco Santander  (Brasil)  S.A.', value: '033'},
  {text: '743 - Banco Semear S.A.', value: '743'},
  {text: '630 - Banco Smartbank S.A.', value: '630'},
  {text: '366 - Banco Société Générale Brasil S.A.', value: '366'},
  {text: '464 - Banco Sumitomo Mitsui Brasileiro S.A.', value: '464'},
  {text: '082 - Banco Topázio S.A.', value: '082'},
  {text: '634 - Banco Triângulo S.A.', value: '634'},
  {text: '655 - Banco Votorantim S.A.', value: '655'},
  {text: '610 - Banco VR S.A.', value: '610'},
  {text: '119 - Banco Western Union do Brasil S.A.', value: '119'},
  {text: '081 - BancoSeguro S.A.', value: '081'},
  {text: '021 - BANESTES S.A. Banco do Estado do Espírito Santo', value: '021'},
  {text: '755 - Bank of America Merrill Lynch Banco Múltiplo S.A.', value: '755'},
  {text: '250 - BCV - Banco de Crédito e Varejo S.A.', value: '250'},
  {text: '144 - BEXS Banco de Câmbio S.A.', value: '144'},
  {text: '017 - BNY Mellon Banco S.A.', value: '017'},
  {text: '070 - BRB - Banco de Brasília S.A.', value: '070'},
  {text: '104 - Caixa Econômica Federal', value: '104'},
  {text: '320 - China Construction Bank (Brasil) Banco Múltiplo S.A.', value: '320'},
  {text: '477 - Citibank N.A.', value: '477'},
  {text: '487 - Deutsche Bank S.A. - Banco Alemão', value: '487'},
  {text: '064 - Goldman Sachs do Brasil Banco Múltiplo S.A.', value: '064'},
  {text: '062 - Hipercard Banco Múltiplo S.A.', value: '062'},
  {text: '269 - HSBC Brasil S.A. - Banco de Investimento', value: '269'},
  {text: '492 - ING Bank N.V.', value: '492'},
  {text: '652 - Itaú Unibanco Holding S.A.', value: '652'},
  {text: '341 - Itaú Unibanco S.A.', value: '341'},
  {text: '488 - "JPMorgan Chase Bank, National Association"', value: '488'},
  {text: '399 - Kirton Bank S.A. - Banco Múltiplo', value: '399'},
  {text: '128 - MS Bank S.A. Banco de Câmbio', value: '128'},
  {text: '254 - Paraná Banco S.A.', value: '254'},
  {text: '125 - Plural S.A. - Banco Múltiplo', value: '125'},
  {text: '751 - Scotiabank Brasil S.A. Banco Múltiplo', value: '751'},
  {text: '118 - Standard Chartered Bank (Brasil) S/A–Bco Invest.', value: '118'},
  {text: '095 - Travelex Banco de Câmbio S.A.', value: '095'},
  {text: '129 - UBS Brasil Banco de Investimento S.A.', value: '129'}
]




// WEBPACK FOOTER //
// ./src/shared/Banks.js